import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ToasterItemComponent } from '../toaster-item/toaster-item.component';
import { Observable } from 'rxjs';
import { ToasterModel } from '../../toaster.model';
import { ToasterService } from '../../toaster.service';

@Component({
  selector: 'toaster-list',
  standalone: true,
  imports: [CommonModule, ToasterItemComponent],
  templateUrl: './toaster-list.component.html',
  styleUrl: './toaster-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToasterListComponent {
  toasters$: Observable<Array<ToasterModel>> = this.toasterServ.toasters$.asObservable();

  constructor(private toasterServ: ToasterService) {}
}
